import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { environment } from '@environments/environment';
import { GlobalFunctions, SnackType } from '@global/GlobalFunctions';

/** UpdateService */
@Injectable({ providedIn: 'root' })
export class UpdateService {

	private localDev = environment.localsite; // or use your environment flag

	/** checkInterval */
	private checkInterval = environment.production ? 600000 : 60000; // 10 minutes in production, 1 minute in development

	/** updateAvailable$ */
	public updateAvailable$ = new BehaviorSubject(false);

	/**
	 * constructor
	 * @param updates 
	 */
	constructor(
		private updates: SwUpdate,
		private globalFunctions: GlobalFunctions) {

		if (!this.localDev && updates.isEnabled) {
			// Only check and subscribe in production
			setInterval(async () => {
				try {
					await this.updates.checkForUpdate();
				} catch (e) {
					// console.error('Update check failed', e);
				}
			}, this.checkInterval);

			updates.versionUpdates.subscribe(event => {
				if (event.type === 'VERSION_READY') {
					this.updateAvailable$.next(true);
				}
			});
		}
	}

	/**
	 * activateUpdate
	 * @param userConfirm Display a user confirmation box?
	 * @returns 
	 */
	public async activateUpdate(userConfirm: boolean = true): Promise<boolean> {

		/** If not requested to run silently */
		if (userConfirm) {
			/** Create a blocking dialogue confirmation */
			const okResult = await firstValueFrom(
				this.globalFunctions.UserConfirm$('Install new application version?', 'Upgrade Application')
			);

			/** Chak we have a result */
			if (!okResult) {
				this.globalFunctions.DisplaySnackBar({ message: "Update Canceled", duration: 1000 })
				return false;
			}
		}

		/** Display a small prompt to user */
		this.globalFunctions.DisplaySnackBar({
			message: "Updating application - Site will reload shortly",
			type: SnackType.Info,
			// action: "",
			duration: 2000
		})

		/** Schedule the reload to see the snackbar */
		setTimeout(async () => {
			await this.updates.activateUpdate();
			document.location.reload();
		}, 2000);

		return true; // technically never reached after reload, but correct signature

	}

	/**
	 * updateNow
	 * @returns 
	 */
	public async updateNow(): Promise<boolean> {

		await this.updates.activateUpdate();

		this.globalFunctions.DisplaySnackBar({
			message: "Application has been updated.",
			duration: 2000,
			action: ""
		});
		
		document.location.reload();

		return true; // technically never reached after reload, but correct signature
	}
}